import ChallengeDialog from "./shield/ChallengeDialog";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import App from "./App";
import { I18nProvider } from "./i18n";
import { Toaster } from "./components/Toaster";
import "./styles/app.css";

const router=createBrowserRouter([{path:"*",element:<><App/><Toaster/><ChallengeDialog/></>}]);

const queryClient = new QueryClient({ defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false } } });

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <I18nProvider>
        <RouterProvider router={router}/>
      </I18nProvider>
    </QueryClientProvider>
  </StrictMode>,
);
